import { Location } from "@angular/common";
import { Inject, inject, Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { environment } from "environments/environment";

import { NB_WINDOW } from "@nebular/theme";
import { delay, filter, map } from "rxjs/operators";
declare const gtag: any;

@Injectable()
export class AnalyticsService {
  private location = inject(Location);
  private router = inject(Router);
  private enabled: boolean;

  constructor(@Inject(NB_WINDOW) private window: any) {
    if (environment.gtm) {
      this.addGAScript();
    }
    this.enabled = environment.gtm;
  }

  trackPageViews(): void {
    if (this.enabled) {
      this.router.events
        .pipe(
          filter((event) => event instanceof NavigationEnd),
          map(() => this.location.path()),
          filter((location: string) => this.trackLocation(location)),
          delay(50),
        )
        .subscribe((location: string) =>
          this.gtmPushToDataLayer({ event: "pageView", path: location }),
        );
    }
  }

  trackEvent(params: any): void {
    if (this.enabled) {
      this.gtmPushToDataLayer(params);
    }
  }

  private trackLocation(path: string) {
    if (
      path.match(/\/components\/[a-zA-Z-]+\/?$/) ||
      path.match(/\/docs\/?$/) ||
      path.match(/\/example\//)
    ) {
      return !!path.match(/\/components\/components-overview\/?$/);
    }
    return true;
  }

  private gtmPushToDataLayer(params: any): void {
    this.window.dataLayer.push(params);
  }

  /** Add Google Analytics Script Dynamically */
  addGAScript(): void {
    this.window.dataLayer = this.window.dataLayer || [];
    this.window.gtag = function () {
      (window as any).dataLayer.push(arguments);
    };

    // 2. Initial configuration
    this.window.gtag("js", new Date());
    this.window.gtag("config", environment.gaId, { send_page_view: false });

    // 3. Dynamically inject the external script
    const gtagScript: HTMLScriptElement = document.createElement("script");
    gtagScript.async = true;
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${environment.gaId}`;

    // Use the injected window/document context for safety
    document.head.prepend(gtagScript);
  }
}
